import { useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, doc, getDoc, updateDoc } from 'firebase/firestore';

// Listens to buyer-seller conversation messages for a given conversation id
export const useBuyerSellerConversationListener = ({
  db,
  conversation,
  user,
  dispatch,
  offlineStorage,
  pendingMessages
}) => {
  useEffect(() => {
    if (!conversation || !user) return;
    if (!(conversation.buyer && conversation.seller)) return;

    dispatch({ type: 'SET_FIRESTORE_LOADING', payload: true });

    const messagesCol = collection(db, 'sellerbuyerconversations', conversation.id, 'messages');
    const q = query(messagesCol, orderBy('timestamp', 'asc'));

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      const msgs = await Promise.all(snapshot.docs.map(async (docSnapshot) => {
        const data = docSnapshot.data();
        // Update order message status from conversation document
        if (data.type === 'order' && data.order_id) {
          const convRef = doc(db, 'sellerbuyerconversations', conversation.id);
          const convDoc = await getDoc(convRef);
          if (convDoc.exists()) {
            const convData = convDoc.data();
            if (convData.order_id === data.order_id && convData.status !== data.status) {
              const messageRef = doc(db, 'sellerbuyerconversations', conversation.id, 'messages', docSnapshot.id);
              await updateDoc(messageRef, { status: convData.status });
            }
          }
        }
        return {
          id: docSnapshot.id,
          ...data,
          time: data.timestamp ? new Date(data.timestamp.toDate()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        };
      }));

      dispatch({ type: 'SET_FIRESTORE_MESSAGES', payload: msgs });
      dispatch({ type: 'SET_FIRESTORE_LOADING', payload: false });

      try {
        if (offlineStorage) offlineStorage.cacheMessages(conversation.id, msgs);
      } catch {}
    });

    return () => unsubscribe();
  }, [db, conversation && conversation.id, user && (user.uid || user.email), dispatch, offlineStorage]);
};

export default useBuyerSellerConversationListener;


